
import { IItemCacheThunkAction } from '../store/actions/ItemCacheActions';
import { ControlFacet } from '../models/controls/ControlFacet';
import { IWithWizardInjectedProps } from '../components/decorators/withWizard';
/**
 * The properties to pass to the callout containing the sharing dialog
 * @public
 */
export interface ISharingWizardProps extends IWithWizardInjectedProps {
  /**
   * Returns information about the item shared
   */
  getSharingInformation: () => Promise<ISharingInformation>;

  /**
   * Returns the clientId used in telemetry
   */
  getClientId: () => string;

  /**
   * Item key of the shared item
   */
  itemKey: string;

  /**
   * 1 for sharing mode, 2 for copy link mode, 7 for add people
   */
  mode: 1 | 2 | 7;

  /**
   * List of recipients to populate the people picker with
   */
  defaultRecipients?: Array<string>;

  /**
   * Allows adding a custom labeled audience  option in the link settings view. ICustomLabeledAudienceConfig object
   */
  customLabeledAudienceConfig?: {
    entityName: string;
    iconUrl?: string;
  };
}

/**
 * @public
 */
export interface ISharingInformation {
  /**
   * If using token based authentication, authToken,
   * webAbsoluteUrl, listUrl, and serverRelativeItemUrl
   * are all required. listUrl and serverRelativeItemUrl
   * together identify the item.
   */
  authToken?: string;
  webAbsoluteUrl?: string;
  listUrl?: string;
  serverRelativeItemUrl?: string;
  /**
   * If using cookie based authentication, only
   * cookieAuthIframeUrl is required.
   */
  cookieAuthIframeUrl?: string;
}

/**
 * @public
 */
export interface IShareActionControlProps {
  itemKey: string;
}

/**
 * @public
 */
export interface IShareActionControlOverrides {
  /**
   * Indicates whether the action is available or not
   */
  isAvailable: boolean;

  /**
   * List of recipients to populate the people picker with
   */
  defaultRecipients: Array<string>;

  /**
   * Allows adding a custom labeled audience  option in the link settings view. ICustomLabeledAudienceConfig object
   */
  customLabeledAudienceConfig: {
    entityName: string;
    iconUrl?: string;
  } | undefined;

  /**
   * Retrieves information about the item that will be shared
   */
  getSharingInformation: () => IItemCacheThunkAction<Promise<ISharingInformation>>;
}

/**
 * @public
 */
export const shareActionControl: ControlFacet<IShareActionControlProps, IShareActionControlOverrides> =
  new ControlFacet('shareActionControl');
